import React, { FC, useState } from "react";

import { useMatchParams } from "kanopi-components/hooks/useMatchParams";
import {
  QuestionFlowComponent,
  QuestionFlowTypeEnum,
} from "kw/components/QuestionFlow/QuestionFlowComponent";
import { quoteFlowFields } from "kw/api/fragments";
import { RouteComponentProps } from "@reach/router";

type TKnockoutFlowPage = {
  riskProfileId: string;
};
export const KnockoutFlowPage: FC<TKnockoutFlowPage & RouteComponentProps> = ({
  riskProfileId,
  uri: prefix,
}) => {
  const { questionSetKey } = useMatchParams(`${prefix}/:questionSetKey`);
  const startQuoteQuery = {
    startKnockouts: [
      {
        input: {
          riskProfileId: riskProfileId,
          questionSetKey: questionSetKey,
        },
      },
      { ...quoteFlowFields },
    ],
  };
  const [currentMaxSet, setCurrentMaxSet] = useState({
    currentSet: 0,
    maxSets: 1,
  });
  const onCurrentMaxSetChange = (currentSet, maxSets) => {
    const _totalSets = { ...currentMaxSet };
    _totalSets.currentSet = !questionSetKey && currentSet === maxSets ? 0 : currentSet;
    _totalSets.maxSets = maxSets;
    setCurrentMaxSet(_totalSets);
  };

  return (
    <QuestionFlowComponent
      isFlowLayout={true}
      actionFlowType={QuestionFlowTypeEnum.Quote}
      prefix={`/quoting/knockout/${riskProfileId}`}
      finishedRoute={`/quoting/policyholders/${riskProfileId}`}
      defaultBackLocation="/quote/ready"
      actionQuery={startQuoteQuery}
      questionFlowResponseKey="startKnockouts"
      questionSetKey={questionSetKey}
      steps={[
        {
          label: "Your details",
          complete: true,
        },
        { label: "Your quote", complete: true },
        {
          label: "Review and buy",
          active: true,
          current: 1,
          total: 3,
        },
      ]}
      onCurrentAndMaxSetChange={onCurrentMaxSetChange}
    />
  );
};
